import * as React from 'react'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import SignedInvoicesDatatable from './SignedInvoicesDatatable'

interface ContentProps {}

const Content = ({ children }: React.PropsWithChildren<ContentProps>) => {
  const [tabs, setTabs] = React.useState([
    {
      id: 'all',
      active: true,
      label: i18n.t('expenses.settings.signed_invoices.list.table.invoice_state.all'),
    },
    {
      id: 'ready_to_close',
      active: false,
      label: i18n.t('expenses.settings.signed_invoices.list.table.invoice_state.ready_to_close'),
    },
    {
      id: 'not_ready_to_close',
      active: false,
      label: i18n.t(
        'expenses.settings.signed_invoices.list.table.invoice_state.not_ready_to_close'
      ),
    },
    {
      id: 'closed',
      active: false,
      label: i18n.t('expenses.settings.signed_invoices.list.table.invoice_state.closed'),
    },
  ])

  return (
    <Tabs
      currentId={tabs.find((tab) => tab.active)?.id ?? ''}
      onTabClicked={(tabId) => {
        setTabs(
          tabs.map((tab) => {
            if (tab.id === tabId) {
              return {
                ...tab,
                active: true,
              }
            }
            return {
              ...tab,
              active: false,
            }
          })
        )
      }}
    >
      {tabs.map(({ id, label }) => (
        <Tabs.Tab key={id} id={id} label={label}>
          <Box paddingTop="s32">
            <SignedInvoicesDatatable
              invoicesState={
                tabs.filter(({ active, id: tabId }) => !!active && tabId !== 'all')[0]?.id
              }
            />
            {children}
          </Box>
        </Tabs.Tab>
      ))}
    </Tabs>
  )
}

export default Content
